import { render } from "./ProporsionOfFailedVsFinishedPerBankChart.vue?vue&type=template&id=81c3e028"
import script from "./ProporsionOfFailedVsFinishedPerBankChart.vue?vue&type=script&lang=js"
export * from "./ProporsionOfFailedVsFinishedPerBankChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__